import React from 'react'
import Seo from './common/Seo';
import Hero from './careers/Hero';
import Values from './careers/Values';
import Culture from './careers/Culture';
import ClosingCTA from './careers/ClosingCTA';

const Careers = () => {
    return (
        <>
            <Seo
              title="채용"
              description="MTST와 함께 스마트 제조의 미래를 만들어갈 동료를 찾습니다. 채용 정보와 회사 문화를 확인하세요."
              path="/careers"
            />
            <Hero/>
            <Values/>
            <Culture/>
            <ClosingCTA/>
        </>
    );
}

export default Careers
